import { Dialog as MuiDialog, withStyles } from "@material-ui/core";

const StyledDialog = withStyles(() => ({
  paper: {
    "&.MuiPaper-rounded": {
      borderRadius: 8
    }
  }
}))(MuiDialog)

export const Dialog = ({ isOpen, onClose, children }) => {
  return (
    <StyledDialog
      open={isOpen}
      onClose={onClose}
    >
      { children }
    </StyledDialog>
  )
}
